if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.zoomViewer = this.querySelector('[data-tsc-zoom-viewer]');
        if (!this.zoomViewer) return;

        this.zoomStage = this.querySelector('[data-tsc-zoom-stage]');
        this.zoomImage = this.querySelector('[data-tsc-zoom-image]');
        this.zoomRange = this.querySelector('[data-tsc-zoom-range]');
        this.zoomValue = this.querySelector('[data-tsc-zoom-value]');
        this.zoomCount = this.querySelector('[data-tsc-zoom-count]');
        this.zoomNavigation = this.querySelector('[data-tsc-zoom-navigation]');
        this.heightCalculatorLink = this.querySelector('[data-tsc-height-calculator]');
        this.zoomLevel = 1;
        this.panX = 0;
        this.panY = 0;
        this.activePointers = new Map();

        this.zoomViewer.addEventListener('pointerup', (event) => event.stopPropagation());
        this.zoomRange.addEventListener('input', () => this.setZoom(Number(this.zoomRange.value)));
        this.querySelector('[data-tsc-zoom-previous]').addEventListener('click', () => this.showZoomImage(this.zoomIndex - 1));
        this.querySelector('[data-tsc-zoom-next]').addEventListener('click', () => this.showZoomImage(this.zoomIndex + 1));
        this.zoomImage.addEventListener('load', () => this.renderZoom());

        this.zoomStage.addEventListener('pointerdown', (event) => {
          if (this.activePointers.size >= 2) return;
          this.activePointers.set(event.pointerId, { x: event.clientX, y: event.clientY });
          this.zoomStage.setPointerCapture(event.pointerId);
          if (this.activePointers.size === 1) {
            this.startX = event.clientX;
            this.startY = event.clientY;
            this.startPanX = this.panX;
            this.startPanY = this.panY;
            this.suppressSwipe = false;
          } else {
            const [first, second] = Array.from(this.activePointers.values());
            const bounds = this.zoomStage.getBoundingClientRect();
            const centerX = (first.x + second.x) / 2 - bounds.left - bounds.width / 2;
            const centerY = (first.y + second.y) / 2 - bounds.top - bounds.height / 2;
            this.pinchDistance = Math.max(1, Math.hypot(first.x - second.x, first.y - second.y));
            this.pinchZoom = this.zoomLevel;
            this.pinchFocalX = (centerX - this.panX) / this.zoomLevel;
            this.pinchFocalY = (centerY - this.panY) / this.zoomLevel;
            this.suppressSwipe = true;
          }
        });
        this.zoomStage.addEventListener('pointermove', (event) => {
          if (!this.activePointers.has(event.pointerId)) return;
          this.activePointers.set(event.pointerId, { x: event.clientX, y: event.clientY });
          if (this.activePointers.size === 2) {
            const [first, second] = Array.from(this.activePointers.values());
            const distance = Math.hypot(first.x - second.x, first.y - second.y);
            const bounds = this.zoomStage.getBoundingClientRect();
            const centerX = (first.x + second.x) / 2 - bounds.left - bounds.width / 2;
            const centerY = (first.y + second.y) / 2 - bounds.top - bounds.height / 2;
            this.setZoom(this.pinchZoom * distance / this.pinchDistance);
            this.panX = centerX - this.pinchFocalX * this.zoomLevel;
            this.panY = centerY - this.pinchFocalY * this.zoomLevel;
            this.renderZoom();
          } else if (this.zoomLevel > 1) {
            this.panX = this.startPanX + event.clientX - this.startX;
            this.panY = this.startPanY + event.clientY - this.startY;
            this.renderZoom();
          }
        });
        this.zoomStage.addEventListener('wheel', (event) => {
          if (window.innerWidth < 750) return;
          event.preventDefault();
          const bounds = this.zoomStage.getBoundingClientRect();
          const centerX = event.clientX - bounds.left - bounds.width / 2;
          const centerY = event.clientY - bounds.top - bounds.height / 2;
          const focalX = (centerX - this.panX) / this.zoomLevel;
          const focalY = (centerY - this.panY) / this.zoomLevel;
          this.setZoom(this.zoomLevel * Math.exp(-event.deltaY * 0.0015));
          this.panX = centerX - focalX * this.zoomLevel;
          this.panY = centerY - focalY * this.zoomLevel;
          this.renderZoom();
        }, { passive: false });
        const endPointer = (event, cancelled = false) => {
          if (!this.activePointers.has(event.pointerId)) return;
          const wasSinglePointer = this.activePointers.size === 1;
          const deltaX = event.clientX - this.startX;
          const deltaY = event.clientY - this.startY;
          this.activePointers.delete(event.pointerId);
          if (this.activePointers.size === 1) {
            const remaining = this.activePointers.values().next().value;
            this.startX = remaining.x;
            this.startY = remaining.y;
            this.startPanX = this.panX;
            this.startPanY = this.panY;
          }
          if (wasSinglePointer && !cancelled && !this.suppressSwipe && this.zoomLevel === 1 && Math.abs(deltaX) > 50 && Math.abs(deltaX) > Math.abs(deltaY) * 1.2) {
            this.showZoomImage(this.zoomIndex + (deltaX < 0 ? 1 : -1));
          }
          if (this.activePointers.size === 0) this.suppressSwipe = false;
        };
        this.zoomStage.addEventListener('pointerup', (event) => endPointer(event));
        this.zoomStage.addEventListener('pointercancel', (event) => endPointer(event, true));
        window.addEventListener('resize', () => {
          if (this.zoomViewer.hidden) return;
          this.renderZoom();
        });
      }

      hide() {
        if (this.zoomViewer) {
          this.zoomViewer.hidden = true;
          this.classList.remove('product-media-modal--zoom-viewer');
          this.zoomImage.removeAttribute('src');
          this.zoomImage.removeAttribute('srcset');
          this.activePointers.clear();
          this.suppressSwipe = false;
        }
        super.hide();
      }

      show(opener) {
        super.show(opener);
        if (this.showZoomViewer(opener)) return;
        this.showActiveMedia();
      }

      showZoomViewer(opener) {
        if (!this.zoomViewer) return false;
        this.zoomImages = Array.from(this.querySelectorAll('.product-media-modal__content > img[data-media-id]'));
        const index = this.zoomImages.findIndex((image) => image.dataset.mediaId === opener?.dataset.mediaId);
        if (index < 0) return false;

        this.zoomViewer.hidden = false;
        this.classList.add('product-media-modal--zoom-viewer');
        this.zoomNavigation.hidden = this.zoomImages.length < 2;
        this.showZoomImage(index);
        return true;
      }

      showZoomImage(index) {
        this.zoomIndex = (index + this.zoomImages.length) % this.zoomImages.length;
        const source = this.zoomImages[this.zoomIndex];
        if (this.heightCalculatorLink) {
          this.heightCalculatorLink.hidden = !source.hasAttribute('data-tsc-height-calculator-image');
        }
        this.setZoom(1);
        this.zoomCount.textContent = `${this.zoomIndex + 1} / ${this.zoomImages.length}`;
        this.zoomImage.alt = source.alt;
        this.zoomImage.sizes = '300vw';
        this.zoomImage.srcset = source.srcset;
        this.zoomImage.src = source.src;
        this.renderZoom();
      }

      setZoom(level) {
        this.zoomLevel = Math.round(Math.max(1, Math.min(3, level)) * 100) / 100;
        this.zoomRange.value = this.zoomLevel;
        this.zoomRange.setAttribute('aria-valuetext', `${this.zoomLevel.toFixed(1)} times`);
        this.zoomRange.style.setProperty('--tsc-zoom-progress', `${(this.zoomLevel - 1) * 50}%`);
        this.zoomValue.textContent = `${this.zoomLevel.toFixed(1)}×`;
        if (this.zoomLevel === 1) this.panX = this.panY = 0;
        this.renderZoom();
      }

      renderZoom() {
        if (this.zoomViewer.hidden) return;
        this.zoomStage.classList.toggle('is-zoomed', this.zoomLevel > 1);
        const width = this.zoomStage.clientWidth;
        const height = this.zoomStage.clientHeight;
        if (width && height && this.zoomImage.naturalWidth && this.zoomImage.naturalHeight) {
          const fit = Math.min(width / this.zoomImage.naturalWidth, height / this.zoomImage.naturalHeight);
          const maxX = Math.max(0, (this.zoomImage.naturalWidth * fit * this.zoomLevel - width) / 2);
          const maxY = Math.max(0, (this.zoomImage.naturalHeight * fit * this.zoomLevel - height) / 2);
          this.panX = Math.max(-maxX, Math.min(maxX, this.panX));
          this.panY = Math.max(-maxY, Math.min(maxY, this.panY));
        }
        this.zoomImage.style.transform = `translate3d(${this.panX}px, ${this.panY}px, 0) scale(${this.zoomLevel})`;
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
